import { render, staticRenderFns } from "./CustomerImportEmailSent.vue?vue&type=template&id=78a1f6df&"
import script from "./CustomerImportEmailSent.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportEmailSent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports